'use strict';

/**
* @ngdoc service
* @name tcApp.WebsysDateTimeLegacyScope
* @description
* Contains systemUI equivalents for legacy date and time functions originally
* defined in websys.datetime.tools.js & websys.Component
*
*/
angular.module('tc.legacyScope').factory('WebsysDateTimeLegacyScope', function(GlobalService, OverlayService,
									LegacyScopeSearchService, tcConstants) {
	
	/* eslint no-unused-vars:0 */
	return function($scope) {
		var dateConfiguration = {};
		if (angular.isDefined(GlobalService.configuration.date)) {
			dateConfiguration = GlobalService.configuration.date;
		}
		if (dateConfiguration.format === 'DMMMY') {
			var shortMonthsString = GlobalService.getGlobalStrings().XMONTHSSHORT;
			var shortMonths = shortMonthsString.split(',');
			var shortMonthsUpperCase = shortMonthsString.toUpperCase().split(',');
		}
		var timeConfiguration = {};
		if (angular.isDefined(GlobalService.configuration.time)) {
			timeConfiguration = GlobalService.configuration.time;
		}
		var msPerDay = 86400000; //milliseconds in one day
		var cacheToJS = 47117;
		
		// Reformats a given day, month and year to the configured date format
		var reWriteDate = function(d, m, y) {
			var centuryWindow = dateConfiguration.centuryWindow;
			var format = dateConfiguration.format;
			
			y = parseInt(y, 10);
			if (y < centuryWindow) {
				y += ((format === 'THAI') ? 2500 : 2000);
			} else if (y < 100) {
				y += ((format === 'THAI') ? 2400 : 1900);
			}
			// If Thai format, treat passed in year < 2384 (logical date = 1841) as Gregorian year
			// (This could happen when year is extracted from dateObject.getFullYear())
			if ((format === 'THAI') && (String(y).length === 4) && (y <2384)) {
				y += tcConstants.DATE_OPTIONS.THAI_YEAR_SHIFT;
			}
			d = parseInt(d, 10);
			if (d < 10) d = '0' + String(d);
			m = parseInt(m, 10);
			if (m < 10) m = '0' + String(m);
			if (format === 'DMMMY') m = shortMonths[Number(m) - 1];
			
			var newdate = '';
			if (format === 'YMD') {
				newdate = y + dateConfiguration.separator + m + dateConfiguration.separator + d;
			} else if (format === 'MDY') {
				newdate = m + dateConfiguration.separator + d + dateConfiguration.separator + y;
			} else if (format === 'DMMMY') {
				newdate = d + ' ' + m + ' ' + y;
			} else {
				// DMY
				newdate = d + dateConfiguration.separator + m + dateConfiguration.separator + y;
				// THAI formatting is handled by dateParser.js
			}
			return newdate;
		};
		
		// Returns whether the date field has a valid date value
		var isValidDate = function(item) {
			if (!item) return true;
			if (angular.isUndefined($scope.componentForm[$scope.componentHtmlName])) return true;
			if (angular.isUndefined($scope.componentForm[$scope.componentHtmlName][item.id])) return true;
			
			// Validation is handled by date parser, just check for invalid model state
			if ($scope.componentForm[$scope.componentHtmlName][item.id].$error['date']) {
				return false;
			}
			
			return true;
		};
		
		//converts the today character format to the current date
		//allows for addition and subtraction from today
		var convertTDate = function(fld) {
			var format = dateConfiguration.format;
			var maxdays = dateConfiguration.maxAdditionDays;
			var todaych = dateConfiguration.todaySymbol;
			var dt = fld.value;
			var re = /(\s)+/g;
			dt = dt.replace(re, '');
			if (dt.charAt(0).toUpperCase() == todaych) {
				var today = new Date();
				if (format == 'THAI') {
					today.setYear(today.getFullYear() + tcConstants.DATE_OPTIONS.THAI_YEAR_SHIFT);
				}
				var xdays = dt.slice(2);
				if (xdays == '') xdays = 0;
				if (isNaN(xdays)) return 0;
				if (maxdays) {
					if ((dt.charAt(1) == '+') && (xdays > maxdays)) return 0;
				}
				var xDaysMs = xdays * 24 * 60 * 60 * 1000;
				if (dt.charAt(1) == '+') {
					today.setTime(today.getTime() + xDaysMs);
				} else if (dt.charAt(1) == '-') {
					today.setTime(today.getTime() - xDaysMs);
				} else if (dt.length > 1) {
					return 0;
				}
				fld.value = reWriteDate(today.getDate(), today.getMonth() + 1, today.getFullYear());
				return 1;
			}
			return 0;
		};
		
		// Reformats a given hours, minutes and seconds to the configured time format
		var reWriteTime = function(hours, minutes, seconds) {
			var newTime = '';
			if (hours < 10) hours = '0' + hours;
			if (minutes < 10) minutes = '0' + minutes;
			if (seconds < 10) seconds = '0' + seconds;
			newTime = (hours + timeConfiguration.separator + minutes);
            
			return newTime;			
		};
		
		// Returns whether the time field has a valid time value
		var isValidTime = function(item) {
			if (!item) return true;
			if (angular.isUndefined($scope.componentForm[$scope.componentHtmlName])) return true;
			if (angular.isUndefined($scope.componentForm[$scope.componentHtmlName][item.id])) return true;
			
			// Validation is handled by time parser, just check for invalid model state
			if ($scope.componentForm[$scope.componentHtmlName][item.id].$error['time']) {
				return false;
			}
			return true;
		};
		
		// Converts a field value from time character format to the current time
		var convNTime = function(fld) {
			var now = new Date();
			var value = fld.value;
			var regEx = /(\s)+/g;
			value = value.replace(regEx, '');
			if (value.charAt(0).toUpperCase() === dateConfiguration.nowSymbol) {
				var xmin = value.slice(2);
				if (xmin === '') xmin = 0;
				if (isNaN(xmin)) return 0;
				var xminMs = (xmin * 60 * 1000);
				if (value.charAt(1) === '+') {
					now.setTime(now.getTime() + xminMs);
				} else if (value.charAt(1) == '-') {
					now.setTime(now.getTime() - xminMs);
				} else if (value.length > 1) {
					return 0;
				}
				fld.value = reWriteTime(now.getHours(), now.getMinutes(), now.getSeconds());
				return 1;
			}
			return 0;
		};
		
		/* websys.datetime.tools.js functions */
		
		// Given a date string, returns an object with year, month and day properties
		var dateStringToArray = function(dateString) {
			if (angular.isUndefined(dateString)) return null;
            
			var dateObject = {
				yr: '',
				mn: '',
				dy: ''
			};
			if ((dateConfiguration.format === 'HIJRA') && (dateString.indexOf(' [') !== -1)) {
				dateString = dateString.slice(0, dateString.indexOf(' ['));
			}
			if ((dateConfiguration.format === 'THAI') && (dateString.indexOf(' [') !== -1)) {
				dateString = dateString.slice(0, dateString.indexOf(' ['));
			}
			var arrDate = dateString.split(dateConfiguration.separator);
			switch (dateConfiguration.format) {
				case 'YMD':
					dateObject['yr'] = parseInt(arrDate[0], 10);
					dateObject['mn'] = parseInt(arrDate[1], 10);
					dateObject['dy'] = parseInt(arrDate[2], 10);
				break;
				case 'MDY':
					dateObject['yr'] = parseInt(arrDate[2], 10);
					dateObject['mn'] = parseInt(arrDate[0], 10);
					dateObject['dy'] = parseInt(arrDate[1], 10);
				break;
				case 'DMMMY':
					dateObject['yr'] = parseInt(arrDate[2], 10);
					dateObject['mn'] = arrDate[1];
					if (dateObject['mn']) {
						dateObject['mn'] = dateObject['mn'].toUpperCase();
						// Convert month in words to number
						angular.forEach(shortMonthsUpperCase, function(shortMonth, monthIndex) {
							if (dateObject['mn'] === shortMonth) {
								dateObject['mn'] = (1 + monthIndex);
							}
						});
					}
					dateObject['dy'] = parseInt(arrDate[0], 10);
				break;
				case 'HIJRA': //fall through
				case 'THAI': //fall through
				default: //treat as DMY
					dateObject['yr'] = parseInt(arrDate[2], 10);
					dateObject['mn'] = parseInt(arrDate[1], 10);
					dateObject['dy'] = parseInt(arrDate[0], 10);
				break;
			}
			return dateObject;
		};
		
		// Given a date object with year, month and day properties, returns an formatted date string
		var dateArrayToFormatString = function(dateObject) {
			var dateString = '';
			switch (dateConfiguration.format) {
				case 'DMMMY':
					if (dateObject['dy'] < 10) {
						dateObject['dy'] = ('0' + dateObject['dy']);
					}
					dateString = dateObject['dy'] + ' '
						+ shortMonthsUpperCase[parseInt(dateObject['mn'], 10) - 1] + ' ' + dateObject['yr'];
				break;
				case 'YMD':
				case 'MDY':
				case 'HIJRA':	//NEXT
				case 'THAI':	//NEXT
				default:	//DMY format
					dateString = reWriteDate(dateObject['dy'], dateObject['mn'], dateObject['yr']);
				break;
			}
			return dateString;
		};
		
		// Returns a formatted date string for today's date
		var dateStringToday = function() {
			var today = new Date();
			var year = today.getFullYear();
			if (dateConfiguration.format === 'THAI') year += tcConstants.DATE_OPTIONS.THAI_YEAR_SHIFT;
			
			return reWriteDate(today.getDate(), (today.getMonth() + 1), year);
		};
		
		// Returns a formatted time string for the time now
		var timeStringNow = function() {
			var now = new Date();
			return reWriteTime(now.getHours(), now.getMinutes(), now.getSeconds());
		};
		
		// Given a formatted time string, returns an object with hour and minute properties
		var timeStringToArray = function(timeString) {
			var timeArray = timeString.split(timeConfiguration.separator);
			return {
				hr: timeArray[0],
				mn: timeArray[1]
			};
		};
		
		// Given a formatted date string, returns a JavaScript date object
		var dateStringToDateObj = function(dateString, convertToUTC) {
			var dateObject = dateStringToArray(dateString);
			var yr = dateObject['yr'];
			if (dateConfiguration.format === 'THAI') yr -= tcConstants.DATE_OPTIONS.THAI_YEAR_SHIFT;
			// need to convert to UTC date to take into account DST for day calculations
			if (angular.isDefined(convertToUTC) && (convertToUTC)) {
				return new Date(Date.UTC(yr, (dateObject['mn'] - 1), dateObject['dy'], 0, 0, 0));
			}
			return new Date(yr, (dateObject['mn'] - 1), dateObject['dy'], 0, 0, 0);
		};
		
		// Given formatted date and time strings, returns a JavaScript date object
		var dateTimeStringToDateObj = function(dateString, timeString, convertToUTC) {
			var dateObject = dateStringToArray(dateString);
			var timeObject = timeStringToArray(timeString);
			var yr = dateObject['yr'];
			if (dateConfiguration.format === 'THAI') yr -= tcConstants.DATE_OPTIONS.THAI_YEAR_SHIFT;
			// need to convert to UTC date to take into account DST for day calculations
			if (angular.isDefined(convertToUTC) && (convertToUTC)) {
				return new Date(Date.UTC(yr, (dateObject['mn'] - 1), dateObject['dy'], timeObject['hr'], timeObject['mn'], 0));
			}
			return new Date(yr, (dateObject['mn'] - 1), dateObject['dy'], timeObject['hr'], timeObject['mn'], 0);
		};
		
		// takes 2 date strings and compares which is the greater
		// returns 0 if the dates are equal.
		// returns -1 if date1 is earlier than date2
		// returns 1 if date1 is after date2
		var dateStringCompare = function(datestr1, datestr2) {
			var objDate1 = dateStringToDateObj(datestr1);
			var objDate2 = dateStringToDateObj(datestr2);
			if (objDate1.getTime() < objDate2.getTime()) return -1;
			if (objDate1.getTime() == objDate2.getTime()) return 0;
			if (objDate1.getTime() > objDate2.getTime()) return 1;
		};
		
		// Takes a date string and compares it to today
		// returns 0 if the date is today.
		// returns -1 if date is earlier than today
		// returns 1 if date is after today
		var dateStringCompareToday = function(dateString) {
			var dateObject = dateStringToDateObj(dateString);
			var today = new Date();
			today.setHours(0);
			today.setMinutes(0);
			today.setSeconds(0);
			today.setMilliseconds(0); //reset gmt hrs
			if (dateObject.getTime() < today.getTime()) return -1;
			if (dateObject.getTime() == today.getTime()) return 0;
			if (dateObject.getTime() > today.getTime()) return 1;
		};
		
		// Takes a date string and compares it to a Cache date
		// returns 0 if the date string is equal to the cache date.
		// returns -1 if date string is earlier than the cache date
		// returns 1 if date string is after the cache date
		var dateStringAndCacheCompare = function(dateString, cacheDate) {
			var dateObject = dateStringToDateObj(dateString);
			var msCacheDate = ((cacheDate - cacheToJS) * msPerDay);
			var cacheDateObject = new Date(msCacheDate);
			cacheDateObject.setHours(0);
			cacheDateObject.setMinutes(0);
			cacheDateObject.setSeconds(0);
			cacheDateObject.setMilliseconds(0); //reset gmt hrs
			if (dateObject.getTime() < cacheDateObject.getTime()) return -1;
			if (dateObject.getTime() == cacheDateObject.getTime()) return 0;
			if (dateObject.getTime() > cacheDateObject.getTime()) return 1;
		};
		
		// Takes 2 date and time strings and compares which is the greater
		// returns 0 if the they are equal.
		// returns -1 if datestr1&timestr1 is earlier than datestr2&timestr2
		// returns 1 if datestr1&timestr1 is after datestr2&timestr2
		var dateTimeStringCompare = function(datestr1, timestr1, datestr2, timestr2) {
			//get Date objects
			var objDate1 = dateTimeStringToDateObj(datestr1, timestr1);
			var objDate2 = dateTimeStringToDateObj(datestr2, timestr2);

			if (objDate1.getTime() < objDate2.getTime()) return -1;
			if (objDate1.getTime() == objDate2.getTime()) return 0;
			if (objDate1.getTime() > objDate2.getTime()) return 1;
		};
		
		// Takes 2 date and time string and compares it to today's date and current time
		// returns 0 if the they are equal.
		// returns -1 if datestr1&timestr1 is earlier than today and current time
		// returns 1 if datestr1&timestr1 is after today and current time
		var dateTimeStringCompareToday = function(datestr1, timestr1) {
			//get Date objects
			var objDate = dateTimeStringToDateObj(datestr1, timestr1);
			var objToday = new Date();
			objToday.setSeconds(0);
			objToday.setMilliseconds(0); //reset gmt seconds, milliseconds
			if (objDate.getTime() < objToday.getTime()) return -1;
			if (objDate.getTime() == objToday.getTime()) return 0;
			if (objDate.getTime() > objToday.getTime()) return 1;
		};
		
		// Takes 2 date strings and returns an object with properties for the differences between the dates
		// differences returned in days,weeks,months,years
		// NB: diff between 30/8/03 and 30/9/04 = 1 year; 13 months
		// but diff between 31/8/03 and 30/9/04 = 1 year; 12 months
		var dateStringDifference = function(datestr1, datestr2) {
			var days = 0;
			var wks = 0;
			var mths = 0;
			var yrs = 0;
			//date subtraction used as date2 - date1 so if date1 is after date2, switch dates around.
			if (dateStringCompare(datestr1, datestr2) == 1) {
				var dtemp = datestr2; datestr2 = datestr1; datestr1 = dtemp;
			}
			var arrD1 = dateStringToArray(datestr1);
			var arrD2 = dateStringToArray(datestr2);
			//need to convert to UTC date to take into account DST for day calculations
			var objD1 = dateStringToDateObj(datestr1, true);
			var objD2 = dateStringToDateObj(datestr2, true);
			days = ((objD2 - objD1) / msPerDay);
			wks = Math.floor(days / 7);
			var xdays = (arrD2['dy'] - arrD1['dy']);
			mths = (arrD2['mn'] - arrD1['mn']);
			yrs = (arrD2['yr'] - arrD1['yr']);
			if (xdays < 0) mths = mths - 1;
			if (mths < 0) {
				mths = mths + 12;
				yrs = yrs - 1;
			}
			mths = ((yrs * 12) + mths);
			return {
				dy: days,
				wk: wks,
				mn: mths,
				yr: yrs	
			};
		};
		
		// Returns an object with properties for the differences between the date string and today
		var dateStringDifferenceToday = function(dateString) {
			return dateStringDifference(dateString, dateStringToday());
		};
		
		// Returns how many days difference between 2 date strings
		var dateStringDifferenceDays = function(datestr1, datestr2) {
			var days = 0;
			// date subtraction used as date2 - date1 so if date1 is after date2, switch dates around.
			if (dateStringCompare(datestr1, datestr2) == 1) {
				var dtemp = datestr2;
				datestr2 = datestr1;
				datestr1 = dtemp;
			}
			//need to convert to UTC date to take into account DST for day calculations
			var objD1 = dateStringToDateObj(datestr1, true);
			var objD2 = dateStringToDateObj(datestr2, true);
			days = ((objD2 - objD1) / msPerDay);
			return days;
		};
		
		// Returns how many days difference between the date string and today
		var dateStringDifferenceDaysToday = function(dateString) {
			return dateStringDifferenceDays(dateString, dateStringToday());
		};
		
		// Converts a short month description to the month number
		var monthsShortToNum = function(month) {
			var found = 0;			
			angular.forEach(shortMonthsUpperCase, function(shortMonth, monthIndex) {
				if (shortMonth === month.toUpperCase()) {
					found = (1 + monthIndex);
				}
			});
			if ((found) && (found < 10)) found = ('0' + found);
			return found;
		};
		
		// Converts a date string to a Cache date, using 01/01/1970 as the reference date
		var dateStringTo$H = function(dateString) {
			var dateObject = dateStringToDateObj(dateString, true);
			var mssince1970 = dateObject.getTime();
			var dayssince1970 = (mssince1970 / msPerDay);
			var cacheDate = (cacheToJS + dayssince1970);
			return cacheDate;
		};
		
		// Returns the Cache date for today
		var dateStringTo$HToday = function() {
			var today = new Date();
			var mssince1970 = today.getTime();
			var dayssince1970 = (mssince1970 / msPerDay);
			var cacheDate = (cacheToJS + dayssince1970);
			return Math.round(cacheDate);
		};
		
		// Converts a Cache date to a date string
		var date$HToString = function(cacheDate) {
			var dateObject = new Date(1970,0,cacheDate - cacheToJS + 1);
			return reWriteDate(dateObject.getDate(), (dateObject.getMonth() + 1), dateObject.getFullYear());
		};
		
		// Converts a time object with hour and minute properties to a formatted string
		var timeArrayToFormatString = function(timeObject) {
			if (timeObject['hr'] < 10) {
				timeObject['hr'] = ('0' + timeObject['hr']);
			}
			if (timeObject['mn'] < 10) {
				timeObject['mn'] = ('0' + timeObject['mn']);
			}
			return (timeObject['hr'] + timeConfiguration.separator + timeObject['mn']);
		};
		
		// Returns the number of days in a month
		// Note that the months start at 0
		var getDaysInMonth = function(Month, Year) {
			var DaysInMonth = 31;
			if ((Month == 3) || (Month == 5) || (Month == 8) || (Month == 10)) DaysInMonth = 30;
			if (Month == 1) {
				DaysInMonth = 28;
				if (Year % 4 == 0) {
					if (Year % 100 != 0) {
						DaysInMonth = 29;
					} else {
						if (Year % 400 == 0) DaysInMonth = 29;
					}
				}
			}
			return DaysInMonth;
		};
		
		// Adds a number of days to the current date and returns the new date
		// Takes into account differing number of days in month, leap years, etc
		var addDays = function(dateObj, Days) {
			var CurrDay = dateObj.getDate();
			var CurrMonth = dateObj.getMonth();
			var CurrYear = dateObj.getFullYear();
			var DaysInMonth = getDaysInMonth(CurrMonth, CurrYear);

			while (Days > 0) {
				CurrDay = CurrDay + 1;
				if (CurrDay > DaysInMonth) {
					CurrMonth = CurrMonth + 1;
					//note that the months start at 0
					if (CurrMonth > 11) {
						CurrMonth = 0;
						CurrYear = CurrYear + 1;
					}
					DaysInMonth = getDaysInMonth(CurrMonth, CurrYear);
					CurrDay = 1;
				}
				Days--;
			}
			dateObj.setFullYear(CurrYear, CurrMonth, CurrDay);

			return dateObj;
		};
		
		// Function adds date and time in specified units
		// Result returned as date and time strings according to current system format.
		// Params:  FormattedDate, FormattedTime, integer AddNo, type: 'M','H','D','WKS','MTH','YRS'
		var addDateTimeFormatted = function(FormattedDate, FormattedTime, AddNo, AddType) {
			var objDate,DateTime,TempTime,objResultDate;
			var ArrayResult = {};
			var ArrayDateResult = {};
			var ArrayTimeResult = {};
			
			ArrayDateResult = dateStringToArray(FormattedDate);
			ArrayTimeResult = timeStringToArray(FormattedTime);
			objDate = dateTimeStringToDateObj(FormattedDate, FormattedTime);
			
			ArrayResult['Date'] = '';
			ArrayResult['Time'] = '';
			
			switch (AddType) {
				case 'M':
					DateTime = objDate.getTime();
					TempTime = DateTime + AddNo * 60 * 1000;
					objResultDate = new Date(TempTime);
				break;
				case 'H':
					DateTime = objDate.getTime();
					TempTime = DateTime + AddNo * 60 * 60 * 1000;
					objResultDate = new Date(TempTime);
				break;
				case 'D':
					// need to do it this way because of daylight saving bug
					objResultDate = addDays(objDate, AddNo);
				break;
				case 'WKS':
					objResultDate = addDays(objDate, (AddNo * 7));
				break;
				case 'MTH':
					var Month = objDate.getMonth();
					var Year = objDate.getFullYear();
					while (AddNo > 11) {
						Year++;
						AddNo -= 12;
					}
					var NewMonth = Month + AddNo;
					if (NewMonth > 11) {
						Year++;
						NewMonth = NewMonth - 12;
					}
					objResultDate = new Date(objDate);
					objResultDate.setMonth(NewMonth);
					objResultDate.setFullYear(Year);
				break;
				case 'YRS':
					objResultDate = new Date(objDate);
					objResultDate.setFullYear(objResultDate.getFullYear() + AddNo);
				break;
				default:
					objResultDate = new Date(objDate);
				break;
			}
			ArrayDateResult['yr'] = objResultDate.getFullYear();
			ArrayDateResult['dy'] = objResultDate.getDate();
			ArrayDateResult['mn'] = objResultDate.getMonth() + 1;
			
			ArrayTimeResult['hr'] = objResultDate.getHours();
			ArrayTimeResult['mn'] = objResultDate.getMinutes();
			
			ArrayResult['Date'] = dateArrayToFormatString(ArrayDateResult);
			ArrayResult['Time'] = timeArrayToFormatString(ArrayTimeResult);
			
			return ArrayResult;
		};
		
		// Takes 2 time strings and compares which is the greater
		// Returns 0 if the times are equal.
		// Returns -1 if time1 is earlier than time2
		// Returns 1 if time1 is after time2
		var timeStringCompare = function(str1, str2) {
			var arrTime1 = timeStringToArray(str1);
			var arrTime2 = timeStringToArray(str2);
			if (arrTime1['hr'] < arrTime2['hr']) return -1;
			if (arrTime1['hr'] == arrTime2['hr']) {
				if (arrTime1['mn'] < arrTime2['mn']) return -1;
				if (arrTime1['mn'] == arrTime2['mn']) return 0;
				if (arrTime1['mn'] > arrTime2['mn']) return 1;
			}
			if (arrTime1['hr'] > arrTime2['hr']) return 1;
		};
		
		// Takes two date time strings and returns the difference between them in hours and minutes
		// Eg.1 date1 = '04/08/2003' time1 = '14:00' date2 = '04/08/2003' time2 = '23:15'
		// => returns an object with 9 hours and 15 minutes
		// Eg.2 date1 = '04/08/2003' time1 = '14:00' date2 = '04/08/2003' time2 = '14:00'
		// => returns an object with 0 hours and 0 minutes
		// Eg.3 date1 = '05/08/2003' time1 = '17:30' date2 = '04/08/2003' time2 = '14:00'
		// => returns an object with 27 hours and 30 minutes
		var dateTimeDiffInHM = function(date1, time1, date2, time2) {
			var objDate1 = dateTimeStringToDateObj(date1, time1);
			var objDate2 = dateTimeStringToDateObj(date2, time2);
			
			var diffDate = new Date();
			diffDate.setTime(Math.abs(objDate1.getTime() - objDate2.getTime()));
			var diffNo = diffDate.getTime();
			
			var days = Math.floor(diffNo / (24 * 60 * 60 * 1000));
			
			var hours = Math.floor(diffNo / (60 * 60 * 1000));
			diffNo -= hours * (60 * 60 * 1000);
			
			var mins = Math.floor(diffNo / (60 * 1000));
			diffNo -= mins * (60 * 1000);
			
			var arrComps = {};
			arrComps['hr'] = hours;
			arrComps['mn'] = mins;
			
			return arrComps;
		};
		
		// Takes two date time strings and returns the difference between them in hours and minutes
		// Eg.1 date1 = '04/08/2003' time1 = '14:00' date2 = '04/08/2003' time2 = '23:15'
		// => returns the string 09:15
		// Eg.2 date1 = '04/08/2003' time1 = '14:00' date2 = '04/08/2003' time2 = '14:00'
		// => returns the string 00:00
		// Eg.3 date1 = '05/08/2003' time1 = '17:30' date2 = '04/08/2003' time2 = '14:00'
		// => returns the string 27:30
		var dateTimeDiffInHMStr = function(date1, time1, date2, time2) {
			var arr = dateTimeDiffInHM(date1, time1, date2, time2);
			var hrmn = reWriteTime(arr['hr'], arr['mn'], 0);
			return hrmn;
		};
		
		// Subtracts a number of days from the date and returns the new date
		var subtractDays = function(dateObj, Days) {
			var CurrDay = dateObj.getDate();
			var CurrMonth = dateObj.getMonth();
			var CurrYear = dateObj.getFullYear();
			while (Days > 0) {
				CurrDay = CurrDay - 1;
				if (CurrDay < 1) {
					CurrMonth = CurrMonth - 1;
					
					//note that the months start at 0
					if (CurrMonth < 0) {
						CurrMonth = 11;
						CurrYear = CurrYear - 1;
					}
					CurrDay = getDaysInMonth(CurrMonth, CurrYear);
				}
				Days--;
			}
			dateObj.setFullYear(CurrYear, CurrMonth, CurrDay);
			return dateObj;
		};
		
		// Subtracts a number of days from the date and returns the new date as a JS object
		var subtractDateStrGetDateObj = function(dateStr, type, addNo) {
			var dateObj = dateStringToDateObj(dateStr);
			var dateNo = dateObj.getTime();
			var addedDate;
			var formatDate;
			//add days
			if (type == 'D') {
				subtractDays(dateObj, addNo);
				return dateObj;
			} else if (type == 'W') {
				//add weeks
				subtractDays(dateObj,(addNo * 7));
				return dateObj;
			}
			// months
			if (type == 'M') {
				var mnth = dateObj.getMonth();
				var yr = dateObj.getFullYear();
				while (addNo > 11) {
					yr--;
					addNo -= 12;
				}
				var newMnth = mnth - addNo;
				if (newMnth < 0) {
					yr--;
					newMnth = newMnth + 12;
				}
				addedDate = new Date(dateObj.getTime());
				addedDate.setMonth(newMnth);
				addedDate.setFullYear(yr);
				return addedDate;
			} else if (type == 'Y') {
				// years
				addedDate = new Date(dateObj.getTime());
				addedDate.setFullYear(dateObj.getFullYear() - addNo);
				return addedDate;
			}
		};
		
		// Takes a datestring (date only,not time)
		// type ('D' = Days, 'W' = Weeks, 'M' = Months, 'Y' = Years), and no. to add to type.
		// Returns a Date object
		var addToDateStrGetDateObj = function(dateStr, type, addNo) {
			var dateObj = dateStringToDateObj(dateStr);
			var dateNo = dateObj.getTime();
			var addedDate;
			var formatDate;
			
			//add days
			if (type == 'D') {
				// ab 8.11.07 - 65334 - need to do it this way because of daylight saving bug
				addDays(dateObj, addNo);
				
				//addedDate = new Date(dateNo + (addNo * 24 * 60 * 60 * 1000));
				//formatDate = ReWriteDate(addedDate.getDate(),addedDate.getMonth()+1,addedDate.getFullYear());
				return dateObj;
			} else if (type == 'W') {
				//add weeks
				//addedDate = new Date(dateNo + (addNo * 7 * 24 * 60 * 60 * 1000));
				addDays(dateObj,(addNo * 7));
				return dateObj;
			} else if (type == 'M') {
				//add months
				var day = dateObj.getDate();
				var mnth = dateObj.getMonth();
				var yr = dateObj.getFullYear();
				while (addNo > 11) {
					yr++;
					addNo -= 12;
				}
				var newMnth = parseInt(mnth) + parseInt(addNo);
				if (newMnth > 11) {
					yr++;
					newMnth = newMnth - 12;
				}
				var DaysInMonth = getDaysInMonth(newMnth, yr);
				if (DaysInMonth < day) {
					day = 1;
					newMnth++;
				}
				addedDate = new Date(dateObj.getTime());
				addedDate.setFullYear(yr);
				addedDate.setMonth(newMnth, day);
				return addedDate;
			} else if (type == 'Y') {
				//add years
				addedDate = new Date(dateObj.getTime());
				addedDate.setFullYear(dateObj.getFullYear() + parseInt(addNo));
				return addedDate;
			}
		};
		
		// Adds a number of days to the passed date and returns the new date as a string
		var addToDateStrGetDateStr = function(dateStr, type, addNo) {
			var dateObj;
			if (addNo < 0) {
				dateObj = subtractDateStrGetDateObj(dateStr, type, parseInt(addNo * -1));
			} else {
				dateObj = addToDateStrGetDateObj(dateStr, type, addNo);
			}
			if (dateObj == null) dateObj = dateStringToDateObj(dateStr);
			var d = reWriteDate(dateObj.getDate(), (dateObj.getMonth() + 1), dateObj.getFullYear());
			return d;
		};
		
		// Takes a date/time and returns the difference between today in hours and minutes
		// Returns an object with hour and minute components
		var dateTimeDiffTodayInHM = function(date1, time1) {
			var objDate1 = dateTimeStringToDateObj(date1, time1);
			var objDate2 = new Date();
			var diffDate = new Date();
			diffDate.setTime(Math.abs(objDate1.getTime() - objDate2.getTime()));
			var diffNo = diffDate.getTime();
			var days = Math.floor(diffNo / (24 * 60 * 60 * 1000));
			
			var hours = Math.floor(diffNo / (60 * 60 * 1000));
			diffNo -= hours * (60 * 60 * 1000);
			
			var mins = Math.floor(diffNo / (60 * 1000));
			diffNo -= mins * (60 * 1000);
			
			var arrComps = {};
			arrComps['hr'] = hours;
			arrComps['mn'] = mins;
			
			return arrComps;
		};
		
		//pass in $H and return Javascript Date object. 
		//Function assumes $h represents a value in the local timezone unless UTC flag is passed in. 
		var DateTime$HToJSDate  = function(cachestring, dateIsUTC) {
			if (cachestring == '') return '';
			var cachestringArray = cachestring.split(',');
			if (cachestringArray.length == 2) {
				var mssince1970 = (cachestringArray[0] - cacheToJS) * msPerDay;
				var d = new Date(mssince1970 + 1000 * cachestringArray[1]);
				if (!dateIsUTC) {
					//JS date by default assumes new dates represent UTC time since Epoch, 
					//so if we've passed in a value representing local data, add an offset 
					// need to use the offset of current - NOT of the one resulting from UTC time
					// - example:
					// SYD DST to Normal: 
					// Saturday before switch: 
					// - now=19:37 (Cache) 
					// - the build UTC is Sun > 3 am for JS if you are in Australia 
					// - that means "d" is "after switch" and returned an TimezoneOffset of -600 (-10h) instead -660 (-11h) 
					// --> the calculation with offset -10 was resulting for "now" = 20:37 and a "can not be in future" 
					var tzdate = new Date();
					var offsetMsec = (tzdate.getTimezoneOffset() * 60000);
					d.setTime(d.getTime() + offsetMsec);
				}
				return d;
			} else {
				return null; 
			}
		};

		//pass in Javascript Date object, returns a $h string that represents the LOCAL date and time 
		//unless 'convertToUTCBeforeStoring' flag is true. 
		//Returns a string representing UTC time if 'convertToUTCBeforeStoring' is false.
		var JSDateToDateTime$H = function(dateObject, convertToUTCBeforeStoring) {
			var dateCopy = new Date(dateObject.getTime());
			if (!convertToUTCBeforeStoring) {
				dateCopy.setTime(dateCopy.getTime() - dateCopy.getTimezoneOffset() * 60000);
			}
		
			var mssince1970 = dateCopy.getTime();
			var cacheDays = Math.floor(mssince1970 / msPerDay) + cacheToJS;
			var cacheSeconds = Math.round((mssince1970 % msPerDay) / 1000.0);
			return cacheDays + ',' + cacheSeconds;
		};
		
		// Takes a date/time and returns the difference between today in hours and minutes
		// Returns a formatted date string
		var dateTimeDiffTodayInHMStr = function(date1, time1) {
			var arr = dateTimeDiffTodayInHM(date1, time1);
			var hrmn = reWriteTime(arr['hr'], arr['mn'], 0);
			return hrmn;
		};
		
		// Converts a JS date object to a formatted date string
		var dateObjectToDateString = function(oDate) {
			var aDate = new Array();
			if (oDate) {
				aDate[0] = oDate.getDate();
				aDate[1] = oDate.getMonth() + 1;
				aDate[2] = oDate.getFullYear();
			}
			return reWriteDate(aDate[0], aDate[1], aDate[2]);
		};
		
		// Generic click handler that opens websys.CalculateDate.Edit
		var calcDateClickHandler = function(linkItem, dateFieldName, calcDateField, componentName, enableAgoFromNow, $event) {
			if (angular.isUndefined(dateFieldName)) return false;
			var obj = LegacyScopeSearchService.getItemFromDataObject($scope, dateFieldName);
			if (angular.isUndefined(obj)) return false;
			if (!isValidDate(obj)) return false;
			if ((obj) && ((obj.disabled) || (obj.readOnly))) return false;

			var patientDOB = LegacyScopeSearchService.getItemFromDataObject($scope, 'PatientDOB');
			var params = '&DateFieldName=' + dateFieldName +
					'&PatientDOB=' + (patientDOB ? patientDOB.value : '') + '&CalcDateField=' + calcDateField +
					'&EnableAgoFromNow=' + (enableAgoFromNow ? enableAgoFromNow : '');
			
			var focusHandler = function($event) {
				if (($event.target) && ($event.target.parentElement)) {
					$event.target.parentElement.focus();	
				} else {
					GlobalService.focusFirst();
				}				
			};
			
			OverlayService.open({
				event: $event,
				componentName: 'websys.CalculateDate.Edit',
				params: params,
				parentComponentName: $scope.componentName,
				focusHandler: focusHandler
			});
			
			return false;
		};
		
		var isDateCalculated = function(item) {
			if (!angular.isObject(item)) return false;	
			if (item.isCalculated === true) {
				return true;
			} else {
				return false;	
			}
		};

		// Return all the functions in an object
		var websysDateTimeFunctions = {
			/* websys.Component functions */
			'ReWriteDate': reWriteDate,
			'IsValidDate': isValidDate,
			'ConvertTDate': convertTDate,
			'ReWriteTime': reWriteTime,
			'IsValidTime': isValidTime,
			'ConvNTime': convNTime,
			
			/* websys.datetime.tools.js functions */
			'DateStringToArray': dateStringToArray,
			'DateArrayToFormatString': dateArrayToFormatString,
			'DateStringToday': dateStringToday,
			'TimeStringNow': timeStringNow,
			'TimeStringToArray': timeStringToArray,
			'DateStringToDateObj': dateStringToDateObj,
			'DateTimeStringToDateObj': dateTimeStringToDateObj,
			'DateStringCompare': dateStringCompare,
			'DateStringCompareToday': dateStringCompareToday,
			'DateStringAndCacheCompare': dateStringAndCacheCompare,
			'DateTimeStringCompare': dateTimeStringCompare,
			'DateTimeStringCompareToday': dateTimeStringCompareToday,
			'DateStringDifference': dateStringDifference,
			'DateStringDifferenceToday': dateStringDifferenceToday,
			'DateStringDifferenceDays': dateStringDifferenceDays,
			'DateStringDifferenceDaysToday': dateStringDifferenceDaysToday,
			'MonthsShortToNum': monthsShortToNum,
			'DateStringTo$H': dateStringTo$H,
			'DateStringTo$HToday': dateStringTo$HToday,
			'Date$HToString': date$HToString,
			'TimeArrayToFormatString': timeArrayToFormatString,
			'GetDaysInMonth': getDaysInMonth,
			'AddDays': addDays,
			'AddDateTimeFormatted': addDateTimeFormatted,
			'TimeStringCompare': timeStringCompare,
			'DateTimeDiffInHM': dateTimeDiffInHM,
			'DateTimeDiffInHMStr': dateTimeDiffInHMStr,
			'SubtractDays': subtractDays,
			'SubtractDateStrGetDateObj': subtractDateStrGetDateObj,
			'AddToDateStrGetDateObj': addToDateStrGetDateObj,
			'AddToDateStrGetDateStr': addToDateStrGetDateStr,
			'DateTimeDiffTodayInHM': dateTimeDiffTodayInHM,
			'DateTimeDiffTodayInHMStr': dateTimeDiffTodayInHMStr,
			'DateObjectToDateString': dateObjectToDateString,
			'CalcDateClickHandler': calcDateClickHandler,
			'IsDateCalculated': isDateCalculated,
			'DateTime$HToJSDate': DateTime$HToJSDate,
			'JSDateToDateTime$H': JSDateToDateTime$H
			
		};
		
		return websysDateTimeFunctions;
	};
});
